import { Context, Layer, type Cause, type Effect, type Scope } from "effect";
import type { AfterCloseAction, AfterCloseCommandFailure } from "./after-close-model.ts";
export class AfterCloseCommandIo extends Context.Service<AfterCloseCommandIo, {
  readonly frame: Effect.Effect<unknown, AfterCloseCommandFailure>;
  readonly run: (action: AfterCloseAction) => Effect.Effect<unknown, AfterCloseCommandFailure>;
}>()("workerstation/frontend/AfterCloseCommandIo") {}
export const AfterCloseCommandIoTest = (io: typeof AfterCloseCommandIo.Service) => Layer.succeed(AfterCloseCommandIo, io);
export interface AfterCloseCommandSession { readonly schedule: (action: unknown) => Effect.Effect<void> }
export class AfterCloseCommands extends Context.Service<AfterCloseCommands, {
  readonly open: (canRun: () => unknown) => Effect.Effect<AfterCloseCommandSession, never, Scope.Scope>;
  readonly failures: Effect.Effect<readonly Cause.Cause<AfterCloseCommandFailure>[]>;
}>()("workerstation/frontend/AfterCloseCommands") {}
